// Mirrors SimpleConfirmationModalComponent: title/subtitle translation keys, optional icon/params.
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export type HorizontalPosition = 'start' | 'center' | 'end';

export interface SimpleConfirmationModalProps {
  titleTranslatePath?: string;
  titlePosition?: HorizontalPosition;
  subtitleTranslatePath?: string;
  subtitlePosition?: HorizontalPosition;
  params?: Record<string, unknown>;
  selectedIconPath?: string;
  iconPosition?: HorizontalPosition;
  iconStyles?: React.CSSProperties;
  cancelText?: string;
  confirmText?: string;
  onClose: (confirmed: boolean | null) => void;
}

const justify = (p?: HorizontalPosition) =>
  p === 'start' ? 'flex-start' : p === 'end' ? 'flex-end' : 'center';

export function SimpleConfirmationModal(props: SimpleConfirmationModalProps) {
  const { t } = useTranslation();
  const title = props.titleTranslatePath
    ? t(props.titleTranslatePath, { defaultValue: props.titleTranslatePath })
    : '';
  const subtitle = props.subtitleTranslatePath
    ? t(props.subtitleTranslatePath, {
        defaultValue: props.subtitleTranslatePath,
        ...(props.params ?? {}),
      })
    : '';

  return (
    <Dialog open onClose={() => props.onClose(null)} maxWidth="xs" fullWidth>
      {props.selectedIconPath && (
        <Box sx={{ display: 'flex', justifyContent: justify(props.iconPosition), pt: 2 }}>
          <Box component="img" src={props.selectedIconPath} sx={props.iconStyles} alt="" />
        </Box>
      )}
      {title && (
        <DialogTitle sx={{ textAlign: justify(props.titlePosition) }}>{title}</DialogTitle>
      )}
      {subtitle && (
        <DialogContent>
          <Typography sx={{ textAlign: justify(props.subtitlePosition) }}>{subtitle}</Typography>
        </DialogContent>
      )}
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={() => props.onClose(false)}>
          {props.cancelText ?? t('global.actions.cancel', { defaultValue: 'Cancel' })}
        </Button>
        <Button variant="contained" onClick={() => props.onClose(true)}>
          {props.confirmText ?? t('global.actions.confirm', { defaultValue: 'Confirm' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
